import Image from 'global/Image';
import { Common } from '@stockbit/ui';
import { Checkbox } from '../styled';

const { Flex, Text } = Common;

interface CommentSettingItemProps {
  icon: string;
  label: string;
  isActive: boolean;
  onChange: () => void;
  [key: string]: any;
}

function CommentSettingItem({ icon, label, isActive, onChange, type }: CommentSettingItemProps) {
  return (
    <Flex className="comment-setting-item" justify="space-between" mt="15px" py="3px" pr="3px" align="center">
      <Flex align="center" width="16" height="16">
        <Image src={`icon/${icon}`} />
        <Text ml="12px" weight="400">
          {label}
        </Text>
      </Flex>
      <Checkbox
        className={`comment-setting-checkbox-${type}`}
        checked={isActive}
        onChange={onChange}
      />
    </Flex>
  );
}

export default CommentSettingItem;
